// Bootstrap JS — import only what we need
// Note: vendor/init.js uses bootstrap.Carousel and imports all of bootstrap,
// which prevents tree-shaking. Migrate it to per-component imports to enable it.

// import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import "bootstrap/js/dist/collapse"; // navbar mobile toggle
import "bootstrap/js/dist/dropdown"; // navbar dropdown (requires @popperjs/core)
// import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/offcanvas';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';

import Parvus from "parvus";

// ** CSS entry point **
import "../scss/docs.scss";

// Component initialisation
import "./vendor/init";

// Init Parvus lightbox gallery
new Parvus({
  l10n: {
    lightboxLabel:
      "Dies ist ein Dialogfenster, das den Hauptinhalt der Seite überlagert. Das Modal zeigt das vergrößerte Bild an. Durch Drücken der Escape-Taste wird das Modal geschlossen.",
    lightboxLoadingIndicatorLabel: "Bild wird geladen",
    lightboxLoadingError: "Das angeforderte Bild konnte nicht geladen werden.",
    controlsLabel: "Steuerung",
    previousButtonLabel: "Vorheriges Bild",
    nextButtonLabel: "Nächstes Bild",
    closeButtonLabel: "Dialogfenster schließen",
    sliderLabel: "Bilder",
    slideLabel: "Bild",
  },
});

// SVE verwendet noch firefox 140, daher funktioniert ::details-content selector "hier" nicht
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".panel-card").forEach((details) => {
    const summary = details.querySelector("summary");
    const content = details.querySelector(".panel-card__body");

    if (!summary || !content) return;

    const closedHeight =
      getComputedStyle(details).getPropertyValue("--closed-height").trim() ||
      "6rem";

    details.open = true;
    details.classList.add("is-collapsed");
    content.style.height = closedHeight;

    summary.addEventListener("click", (event) => {
      event.preventDefault();

      const isCollapsed = details.classList.contains("is-collapsed");

      if (isCollapsed) {
        // Open: fixed teaser height -> real content height -> auto
        details.classList.remove("is-collapsed");
        details.classList.add("is-open");
        content.style.height = closedHeight;

        requestAnimationFrame(() => {
          content.style.height = `${content.scrollHeight}px`;
        });

        content.addEventListener(
          "transitionend",
          () => {
            if (!details.classList.contains("is-collapsed")) {
              content.style.height = "auto";
            }
          },
          { once: true },
        );
      } else {
        // Close: auto/full height -> measured height -> teaser height
        content.style.height = `${content.scrollHeight}px`;

        requestAnimationFrame(() => {
          details.classList.add("is-collapsed");
          details.classList.remove("is-open");
          content.style.height = closedHeight;
        });
      }
    });
  });
});
